export default __webpack_public_path__ + "static/sunset-thumb-a8e0c0ce21ac765111f87c528531818c.jpg";